import React from 'react'

const VerticalThreeDots = () => {
  return (
    <svg
      width="4"
      height="15"
      viewBox="0 0 4 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.99998 14.1673C1.54165 14.1673 1.14942 14.0043 0.823313 13.6782C0.496647 13.3515 0.333313 12.959 0.333313 12.5007C0.333313 12.0423 0.496647 11.6498 0.823313 11.3232C1.14942 10.997 1.54165 10.834 1.99998 10.834C2.45831 10.834 2.85081 10.997 3.17748 11.3232C3.50359 11.6498 3.66665 12.0423 3.66665 12.5007C3.66665 12.959 3.50359 13.3515 3.17748 13.6782C2.85081 14.0043 2.45831 14.1673 1.99998 14.1673ZM1.99998 9.16732C1.54165 9.16732 1.14942 9.00398 0.823313 8.67732C0.496647 8.35121 0.333313 7.95898 0.333313 7.50065C0.333313 7.04232 0.496647 6.64982 0.823313 6.32315C1.14942 5.99704 1.54165 5.83398 1.99998 5.83398C2.45831 5.83398 2.85081 5.99704 3.17748 6.32315C3.50359 6.64982 3.66665 7.04232 3.66665 7.50065C3.66665 7.95898 3.50359 8.35121 3.17748 8.67732C2.85081 9.00398 2.45831 9.16732 1.99998 9.16732ZM1.99998 4.16732C1.54165 4.16732 1.14942 4.00398 0.823313 3.67732C0.496647 3.35121 0.333313 2.95898 0.333313 2.50065C0.333313 2.04232 0.496647 1.6501 0.823313 1.32398C1.14942 0.997318 1.54165 0.833984 1.99998 0.833984C2.45831 0.833984 2.85081 0.997318 3.17748 1.32398C3.50359 1.6501 3.66665 2.04232 3.66665 2.50065C3.66665 2.95898 3.50359 3.35121 3.17748 3.67732C2.85081 4.00398 2.45831 4.16732 1.99998 4.16732Z"
        fill="#999FAC"
      />
    </svg>
  )
}

export default VerticalThreeDots
